import { Button } from '@/components/interactive/Button';
import { SEO } from '@/components/utils/SEO';
import { AtomicMark } from '@/components/visuals/AtomicMark';

export function NotFound() {
  return (
    <>
      <SEO title="404 — Page not found" noIndex />
      <section
        style={{ paddingTop: 200, paddingBottom: 200, textAlign: 'center' }}
      >
        <div className="container">
          <AtomicMark size={56} tone="var(--accent)" />
          <h1 className="text-h1" style={{ marginTop: 32 }}>
            You drifted off the periodic table.
          </h1>
          <p
            className="text-body-lg"
            style={{ marginTop: 20, maxWidth: 540, margin: '20px auto 0' }}
          >
            The page you were looking for isn't here. Most of what's on this
            site lives one click away.
          </p>
          <div style={{ marginTop: 36 }}>
            <Button href="/" variant="primary" size="lg" chevron>
              Go home
            </Button>
          </div>
        </div>
      </section>
    </>
  );
}
